module.exports = __webpack_public_path__ + "static/media/joshua-earles.9096c113.jpg";